<template>
  <page-layout no-padding-top class="contents">

    <!-- 특집형 -->
    <div v-if="isSpecialCate" :key="getCurrentCate.idx">

      <div class="dp_top poll" v-if="isCurrentGNB('poll') || isCurrentGNB('news/cate/10') || isCurrentGNB('news/cate/138') || isCurrentGNB('training')">
        <display-container :section="getCurrentCate.sections[0].idx" :no-auto-link="true" class="title poll">
          <template v-slot="{ component, row }">
            <div class="title_top">
              <p>{{component.getTitle(row)}}</p>
              <p class="text">{{component.getText1(row)}}</p>
            </div>
          </template>
        </display-container>
      </div>

      <div class="dp_top" v-else>
        <display-container :section="getCurrentCate.sections[0].idx" :no-auto-link="true" class="title" :class="{ wsop: isCurrentGNB('news/cate/1')}">
          <template v-slot="{ component, row }">
            <div class="title_top">
              <p>{{component.getTitle(row)}}</p>
              <p class="text">{{component.getText1(row)}}</p>
            </div>
          </template>
        </display-container>
      </div>
      
      <!-- GTO Wizard -->
      <div class="inner" v-if="isCurrentGNB('news/cate/138') || isCurrentGNB('training')">
        <div class="gto">
          <div class="txts">
            <p class="logo">
              <i class="bc"><img src="https://cdn.bluffcatch.com/kr/post/1/contents/40719/logo_bc.png"></i>
              <i class="gw"><img src="https://cdn.bluffcatch.com/kr/post/1/contents/40720/logo_gw.png"></i>
            </p>
            <p class="slogan"><span>Play, Study, </span>Practice, Analyze<br><b>GTO Wizard</b></p>
            <a class="btn" href="https://gtowizard.com/p/bluff&catch" target="_blank"><i>10% Discount</i>Join Now</a>
          </div>
        </div>
      </div>

      <div class="crtn_top" v-if="!isCurrentGNB('poll') && !isCurrentGNB('training') && !isCurrentGNB('news/cate/138')">
        <div class="inner">
          <p class="title">Featured News</p>
          <div class="sect left">
            <display-container :section="getCurrentCate.sections[1].idx">
              <template v-slot="{ component, row }">
                <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                <div class="txt">
                <p class="subj">{{component.getTitle(row)}}</p>
                <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                </div>
              </template>
            </display-container>
          </div>
          <div class="sect right">
            <display-container :section="getCurrentCate.sections[2].idx">
              <template v-slot="{ component, row }">
                <div class="img"><img :src="component.getImage(row)" class="fit_img"></div>
                <div class="txt">
                <p class="subj">{{component.getTitle(row)}}</p>
                <p class="category" :style="`color: ${component.getCateColor(row)}`">{{component.getCate(row)}}</p>
                </div>
              </template>
            </display-container>
          </div>
        </div>
      </div>

    </div>

    <!-- 기본형 -->
    <div class="inner" v-if="!isSpecialCate" :class="isSpecialCate ? 'special' : 'normal'">
      <div class="category">
        <p>Category :</p>
        <p class="ctry_kr">{{getCurrentCate.name}}</p>
        <!--<p class="ctry_en">{{cate.name_eng}}</p-->
      </div>
    </div>

    <sub-page-layout :show-top-banner="isSpecialCate" :class="{poll: isCurrentGNB('poll')}">

        <div class="title">
          <h3 v-if="getCurrentCate.post_cnt">{{getCurrentCate.post_cnt}} Articles</h3>
          <drop-down :data="sortOptions" key-name="key" value-name="value" :default-key="sortKey" :action="clickDrowdownRow"></drop-down>
        </div>

        <div class="poll-tab" v-if="isCurrentGNB('poll')">
          <router-link to="/poll/quiz" :class="{on:isCurrentGNB('poll/quiz')}">Quiz by<img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37814/tips_Logo_Maxvalue.png"></router-link>
          <router-link to="/poll/issue" :class="{on:isCurrentGNB('poll/issue')}">ISSUE</router-link>
        </div>

        <ul class="lst" id="lst" v-if="getCatePosts">
          <li v-for="(post, index) in queryData" :key="index" :class="{ 'has_banner': showSubMiddleBanner(index), 'max-value': isCurrentGNB('poll/quiz') }">

            <div v-if="showSubMiddleBanner(index)" class="banner">
              <display-container :section="313" empty-bg-color="transparent">
                <template v-slot="{ component, row }">
                  <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
                </template>
              </display-container>
              <!--<ins class="adsbygoogle"
               style="display:block"
               data-ad-client="ca-pub-5310971739125617"
               data-ad-slot="1019921057"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>-->
            </div>

            <post-container :post="post"></post-container>
          </li>
        </ul>

        <a class="lst_no" v-if="!getCatePosts.loading && getCatePosts.total < 1">Did not match any articles</a>
        <a class="lst_more" :disabled="getCatePosts.loading" v-if="!isCatePostsFinish && getCatePosts.total > 0" @click="getMoreCatePosts()">Load More Articles</a>

    </sub-page-layout>

  </page-layout>
</template>

<script>
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import {mapGetters} from 'vuex'
  const baseAction = '/post_cates'
  export default {
    name: 'NewsCate',
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getCurrentCate.name}`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Latest news, event info, interviews, industry issues, rankings and strategy`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `${this.getCurrentCate.name} | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Latest news, event info, interviews, industry issues, rankings and strategy`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        baseAction: baseAction,
        sortKey: 'pub_dt',
        sortOptions: [
          {key: 'pub_dt', value: 'Latest'},
          {key: 'view_cnt', value: 'Popularity'}
        ]
      }
    },
    created() {
      this.getRouteQuery()
    },
    activated () {
      this.$store.dispatch('callCatePosts')
      this.$store.dispatch('setCurrentCate')
    },
    beforeRouteUpdate (to, from, next) {
      if (from.params.idx !== to.params.idx) {
        next()
        this.$store.dispatch('callCatePosts')
        this.$store.dispatch('setCurrentCate')
      } else {
        next(false)
      }
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getCatePosts',
        'isCatePostsFinish',
        'getCurrentCate',
        'isExistDisplaySubMiddleBanner'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      isSpecialCate () {
        return this.getCurrentCate.type === 'S'
      },
      queryData () {
        return this.getCatePosts.data.sort((a, b) => a[this.sortKey] < b[this.sortKey] ? 1 : -1)
      }
    },
    methods: {
      ...CommonMethods,
      getRouteQuery() {
        const query = this.$route.query
        const rtn = this.sortOptions.find(row => row.key === query.sort)
        if (rtn) this.sortKey = query.sort
      },
      getMoreCatePosts () {
        this.$store.dispatch('loadCatePosts')
      },
      clickDrowdownRow (row) {
        this.sortKey = row.key
        this.$router.replace({query: {sort: row.key}})
      },
      showSubMiddleBanner (index) {
        return index > 0 && index%6===0 && this.isMobile && this.isExistDisplaySubMiddleBanner
      },
      isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
    },
  }
</script>

<style scoped>
  .contents {
    position: relative;
    top: -40px;
  }
  .dp_top {
    margin-bottom: 50px;
    margin-top: 40px;
  }
  .dp_top.poll {
    margin-top: 0;
  }
  .normal .category {
    display: block;
    text-align: center;
    /*border-bottom: 1px solid #000;*/
    padding-top: 40px;
    padding-bottom: 35px;
  }
  .normal .category p {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  .normal .category p.ctry_kr {
    font-family: 'Roboto Slab' ,'SUIT Variable';
    font-size: 60px;
    font-weight: 900;
  }
  .display-container.title.poll {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
  }
  /deep/ .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  /deep/ .wsop .title_top {
    flex-direction: column;
  }
  /deep/ .wsop .title_top:after {
    background: url(https://cdn.bluffcatch.com/post/20/contents/498/bg-wsop.jpg) no-repeat;
    opacity: 1.0;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  /deep/ .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
  /deep/ .title_top p.text {
    font-size: 30px;
    font-weight: 500;
    text-transform: none;
    margin-top: 10px;
  }
  /* GTO Wiazrd */
  .gto {
    width: 100%;
    height: 400px;
    font-family: 'Poppins';
    color: #fff;
    padding: 50px 100px;
    background: url(https://cdn.bluffcatch.com/kr/post/1/contents/40721/img_training.png) #151f21 no-repeat;
    background-size: 458px auto;
    background-position: 85% -100%;
    border-radius: 8px;
    overflow: hidden;
  }
  .gto .logo i {
    position: relative;
  }
  .gto .logo img {
    height: 30px;
  }
  .gto .logo .bc {
    margin-right: 62px;
  }
  .gto .logo .bc:after {
    content: "×";
    font-size: 46px;
    font-weight: 100;
    color: rgba(255,255,255,0.8);
    position: absolute;
    top: 50%;
    right: -44px;
    transform: translate(0, -38%);
  }
  .gto .slogan {
    font-size: 42px;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.3em;
    margin-top: 45px;
  }
  .gto .slogan b {
    font-weight: inherit;
    color: #aafbb2;
  }
  .gto .btn {
    position: relative;
    display: inline-block;
    font-size: 22px;
    font-weight: 700;
    color: #151f21;
    letter-spacing: -0.02em;
    line-height: 1.0em;
    background: #aafbb2;
    padding: 19px 51px;
    border-radius: 5.0em;
    margin-top: 40px;
    transition: .15s;
  }
  .gto .btn:hover {
    box-shadow: 0 0 30px rgba(270,251,178,0.35);
  }
  .gto .btn i {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -70%);
    background: #1e403d;
    letter-spacing: 0em;
    line-height: 1.0em;
    font-size: 12px;
    font-weight: 500;
    color: #aafbb2;
    padding: 7px 15px;
    border-radius: 5.0em;
    white-space: nowrap;
    transition: .15s;
  }
  .gto .btn i:before {
    content: "";
    display: inline-block;
    position: absolute;
    bottom: 0%;
    left: 50%;
    width: 6px;
    height: 6px;
    background: #1e403d;
    transform: translate(-50%, 50%) rotate(45deg);
  }
  .gto .btn:hover i {
    transform: translate(-50%, -70%) scale(124%,124%);
  }
  .gto .btn:hover i:before {
    transform: translate(-50%, 50%) rotate(45deg) scale(124%,124%);
  }
  .crtn_top .title {
    font-family: 'Roboto Slab';
    font-size: 28px;
    font-weight: 900;
    color: #000;
    margin: 0px 0 20px;
    letter-spacing: -0.02em;
  }
  .crtn_top .title:before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 33px;
    background: url('/statics/img/bi_title.png') no-repeat;
    background-size: contain;
    margin-right: 14px;
  }
  .crtn_top .sect {
    display: inline-block;
    width: 50%;
  }
  .crtn_top .sect /deep/ a {
    border-radius: 8px;
  }
  .crtn_top .sect.left {
    padding-right: 19px;
    border-right: 1px solid #e5e5e5;
  }
  .crtn_top .sect.right {
    padding-left: 20px;
  }
  .crtn_top .sect .display-container {
    width: 100%;
  }
  .crtn_top .sect .display-container .img {
    height: 380px;
    width: 80%;
  }
  .crtn_top .sect .display-container .img img {
    transform: translate(-57%, -50%);
  }
  .crtn_top .sect .display-container .txt {
    position: absolute;
    top: 0;
    right: 0;
    width: 60%;
    height: 380px;
    background: linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1.0) 50%);
    padding: 50px 30px 50px 80px;
  }
  .crtn_top .sect .display-container .subj {
    font-size: 26px;
    font-weight: 700;
    color: #fff;
    text-align: right;
    letter-spacing: -0.02em;
    word-break: normal;
  }
  .crtn_top .sect .display-container .category {
    font-size: 14px;
    font-weight: 600;
    color: #368ee9;
    line-height: 1.0em;
    margin-top: 18px;
    position: absolute;
    right: 30px;
    bottom: 50px;
  }
  .poll .articles .lst > li {
    width: 100% !important;
    border-right: 0;
    padding: 40px 30px 10px;
    border: 1px solid #ccc;
  }
  .poll .articles .lst > li.max-value {
    width: 299px !important;
    border: unset;
    border-right: 1px solid #e5e5e5;
    padding: 0 20px 0 19px;
  }
  .poll .lst > li:nth-child(3n+1) {
    padding-left: 30px;
  }
  .poll .lst > li.max-value:nth-child(3n+1) {
    padding-left: 0;
    width: 280px !important;
  }
  .poll .lst > li.max-value:nth-child(3n+3) {
    padding-right: 0;
    border-right: 0;
    width: 280px !important;
  }
  .poll .poll-tab {
    width: 100%;
    padding: 0;
    /*background: #f1f3f6;*/
    display: inline-block;
    margin: 20px 0 30px;
  }
  .poll .poll-tab a {
    font-size: 20px;
    font-weight: 600;
    color: #999;
		letter-spacing: -0.02em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 60px;
    border-bottom: 2px solid #000;
    transition: 0s;
  }
  .poll .poll-tab a.on {
    font-size: 24px;
    color: #000;
		font-weight: 700;
    border: solid #000;
    border-width: 2px 2px 0 2px;
  }
  .poll .poll-tab a img {
    height: 16px;
    margin-left: 6px;
    opacity: 0.8;
  }
  .poll .poll-tab a.on img {
    height: 18px;
    opacity: 1.0;
  }
</style>
